<template>
  <select
    :value="value"
    :id="idAttr"
    :name="nameAttr"
    :class="{'error': errors.length > 0}"
    @change="(e) => { $emit('input', e.target.value) }">
    <option v-for="option in options" :key="option.value" :value="option.value">{{ option.text }}</option>
  </select>
</template>

<script>
export default {
  name: 'RegistrationFormSelectInput',
  props: {
    options: {
      type: Array,
      default: () => []
    },
    name: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      required: true
    },
    maxlength: {
      type: Number,
      default: 524288
    },
    errors: {
      type: Array,
      default: () => []
    },
    prefix: {
      type: String,
      default: 'customer'
    }
  },
  computed: {
    idAttr: function () { return `${this.prefix}-${this.name}` },
    nameAttr: function () { return `${this.prefix}[${this.name}]` }
  }
}
</script>



// WEBPACK FOOTER //
// src/forms/registration-form/SelectInput.vue